import { render, staticRenderFns } from "./PatientsForm.vue?vue&type=template&id=8ee1181e&scoped=true&"
import script from "./PatientsForm.vue?vue&type=script&lang=js&"
export * from "./PatientsForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientsForm.vue?vue&type=style&index=0&id=8ee1181e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee1181e",
  null
  
)

export default component.exports